<div class="boxs3 margin-top-lg">
	<div class="row margin-bottom-xlg">
		<div class="col-lg-4 col-lg-offset-8">
			<select
				class="form-control input-sm"
				[(ngModel)]="selectedDateRange"
				(change)="dateRangeChange()">
					<option
						*ngFor="let option of dropDownOptions"
						[value]="option.value">
						{{option.label}}
					</option>
			</select>
		</div>
	</div>

	<div class="col-md-12 margin-bottom-xlg">
		<div class="col-md-2">
			<h4>{{'device.status' | translate}}</h4>
		</div>
		<div class="col-md-10">
			<span *ngFor="let key of keys" class="col-md-2">
				<input type="checkbox" [checked]="typesStatus[key]" (change)="updateStatuses(key)" /> {{actFirstService.getGroupName(key)}}
			</span>
		</div>
	</div>

	<div class="col-md-12 margin-bottom-xlg">
		<div class="col-md-2">
			<h4>{{'g.display' | translate}}</h4>
		</div>
		<div class="col-md-10">
			<span class="col-md-2">
				<input type="checkbox" [checked]="displayStatus.avg" (change)="updateDisplay('avg')" /> {{'act_first.average' | translate}}
			</span>
			<span class="col-md-2">
				<input type="checkbox" [checked]="displayStatus.max" (change)="updateDisplay('max')" /> {{'g.max' | translate}}
			</span>
			<span class="col-md-2">
				<input type="checkbox" [checked]="displayStatus.min" (change)="updateDisplay('min')" /> {{'g.min' | translate}}
			</span>
		</div>
	</div>

	<div>
		<h4 class="margin-bottom-xlg">{{availabilityText}}</h4>
		<app-grid-v2
			id="actfirst_hourly_availability_report"
			[columns]="gridColumns"
			[data]="gridRows"
			[settings]="{
				hasSelectColumn: false
			}"
		></app-grid-v2>
	</div>

	<div class="margin-top-lg" *ngFor="let groupChart of groupCharts">
		<simple-widget [title]="groupChart.groupname" *ngIf="hasAnyStatusEnabled && hasAnyDisplayEnabled">
			<div class="margin-bottom toolss2">
				<button class="fa fa-print" data-toggle="tooltip" title="Print" (click)="printChart(groupChart.groupname, groupChart.groupid);"></button>
			</div>
			<div class="margin-top-xlg">
				<line-chart 
					(onChartReady)="generateImageURI($event)"
					[data]="groupChart.dataTable"
					[config]="config"
					[elementId]="groupChart.groupid">
				</line-chart>
			</div>
		</simple-widget>
	</div>
</div>